import styled from 'styled-components';

/**
 * @FIXME: Replace with design system banner once implemented
 */
export const TemporaryBanner = styled.div`
  align-items: center;
  background: white;
  box-shadow: var(--elevation-200);
  display: flex;
  height: 48px;
  justify-content: center;
`;

export const BannerGroup = styled.div`
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 9000;
  min-width: 870px;
`;

export const AlertBanner = styled(TemporaryBanner)`
  background: var(--color-pink-600);
  color: white;
  gap: var(--spacing-small);
`;

export const AlertLinkWrapper = styled.div``;
